import React, {Fragment, PropsWithChildren} from "react";

interface IProps {
	when: boolean;
}

export const Exist: React.FC<PropsWithChildren<IProps>> = ({children, when}) => (
	<Fragment>{when ? children : null}</Fragment>
);
